import React, { useEffect, useState } from 'react';

// Material UI
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import TablePagination from '@mui/material/TablePagination';

import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

// Icons
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

// Components
import TextField from '../../../../components/inputs/input';
import Table from '../../../../components/table';
import EditDetailModal from '../editDetailModal';

// Hooks
import useStyles from './styles';
import useNotify from '../../../../hooks/notify';
import useReception from '../../../../hooks/reception/useReception';

import { columnsReception } from '../../../../models/MovementEntity';
import { stockControllUtils } from '../../../../utils/stockControll-utils';

const MovementDetailsTable = () => {
    const { classes } = useStyles();
    const { Notify, variants } = useNotify();
    const { movement: { products, referrals }, addProduct, addProductMassive, removeProduct, removeReferral, removeProductMassive } = useReception();

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [refId, setRefId] = useState('');
    const [detailSelected, setDetailSelected] = useState(null);
    const [onlyDiff, setOnlyDiff] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    useEffect(() => {
        !referrals?.length > 0 &&
            setUploadedFiles([])
    }, [referrals]);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleAddProduct = async () => {
        if (!(await addProduct(refId)))
            Notify("No se encontró el producto que quiere agregar.", variants.INFO);
        else
            setRefId('');
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter')
            handleAddProduct()
    }

    const handleRemoveProduct = (item) => {
        if (!removeProduct(item.refId))
            Notify("No se encontro el producto que quiere eliminar.", variants.INFO);
        else
            setRefId('');
    }

    const onLoadFile = async (e) => {
        e.preventDefault();

        const file = e.target.files[0];
        const reader = new FileReader();
        const fileName = (file?.name || "").trim();

        if (uploadedFiles.some(f => f.name === fileName)) {
            Notify(`Error, el archivo "${fileName}" ya está cargado actualmente.`, variants.ERROR);
            e.target.value = null;
            return;
        }

        reader.onloadend = async (e) => {
            const content = (e.target.result);
            const refIds = stockControllUtils.parseContent(content);

            if (await addProductMassive(refIds))
                setUploadedFiles([...uploadedFiles, { name: fileName, refIds }]);
            else
                Notify("Error al intentar agregar productos.", variants.INFO);
        };

        reader.readAsText(file);
        e.target.value = null;
    };

    const handleDeleteFile = (fileName) => {
        const file = uploadedFiles.find(f => f.name === fileName);
        if (!file) return;

        removeProductMassive(file.refIds);
        setUploadedFiles(uploadedFiles.filter(f => f.name !== fileName));
    };

    const handleInputChange = (event) => {
        setRefId(stockControllUtils.formatRefId(event.target.value))
    }

    const handleDeleteReferral = ( referralId ) => {
        removeReferral(referralId);
    }

    const handleShowDifferences = (event, value) => 
        setOnlyDiff(value);
    
    const GetRows = () => onlyDiff
        ? products?.filter(p => p.difference !== 0)
        : products;

    return (
        <>
            {   Boolean(detailSelected) &&
                <EditDetailModal
                    open={Boolean(detailSelected)}
                    detail={detailSelected}
                    onClose={() => setDetailSelected(null)}
                />}
            <Grid container spacing={1}>
                <Grid size={12}>
                    <Paper className={classes.paper}>
                        <Typography variant="h4">
                            Ingreso
                        </Typography>
                    </Paper>
                </Grid>
                <Grid size={12}>
                    <Paper>
                        <Grid container>
                            <Grid size={12}>
                                <Grid container spacing={1} style={{ padding: 16 }}>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 4
                                        }}
                                    >
                                        <Typography
                                            component='h2'
                                            color='primary'
                                            variant='h5'
                                        >
                                            Detalles
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 4
                                        }}
                                    >
                                        <TextField
                                            fullWidth
                                            name='refId'
                                            label='SKU o Módulo'
                                            onChange={handleInputChange}
                                            onKey
                                            value={refId}
                                            size='small'
                                            onKeyPress={handleKeyPress}
                                        />
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 2
                                        }}
                                    >
                                        <Button
                                            fullWidth
                                            color='primary'
                                            variant='contained'
                                            onClick={handleAddProduct}
                                            disabled={referrals.length <= 0 || !refId}
                                        >
                                            Agregar
                                        </Button>
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 2
                                        }}
                                    >
                                        <div className="upload-btn-wrapper">
                                            <Button
                                                fullWidth
                                                variant="contained"
                                                component="label"
                                                color='primary'
                                                disabled={referrals.length <= 0}
                                            >
                                                Cargar Archivo
                                                <input
                                                    type="file"
                                                    hidden
                                                    onChange={onLoadFile}
                                                />
                                            </Button>
                                        </div>
                                    </Grid>
                                    <Grid size={12}>
                                        <Divider />
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={1}
                                        style={{ padding: 16 }}
                                        size={{
                                            xs: 12,
                                            md: 6
                                        }}
                                    >
                                        <Grid size={12}>
                                            <Typography
                                                component='h2'
                                                color='primary'
                                                variant='subtitle1'
                                            >
                                                Remitos
                                            </Typography>
                                        </Grid>
                                        <Grid className={classes.chipContainer}>
                                            {   
                                                referrals.map(referral => 
                                                    <Grid key={referral}>
                                                        <Chip 
                                                            label={referral} 
                                                            color="primary"
                                                            className={classes.chip}
                                                            onDelete={() => handleDeleteReferral(referral)} 
                                                        />
                                                    </Grid>
                                                )
                                            }   
                                            {   
                                                referrals.length <= 0 &&
                                                <Grid size={12}>
                                                    <Typography variant='body2'>
                                                        No se ha seleccionado ningun remito para ingresar
                                                    </Typography>
                                                </Grid>
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={1}
                                        style={{ padding: 16 }}
                                        size={{
                                            xs: 12,
                                            md: 6
                                        }}
                                    >
                                        <Grid size={12}>
                                            <Typography
                                                component='h2'
                                                color='primary'
                                                variant='subtitle1'
                                            >
                                                Archivos cargados
                                            </Typography>
                                        </Grid>
                                        <Grid className={classes.chipContainer} size={12}>
                                            {
                                                uploadedFiles.map((file, index) =>
                                                    <Grid key={index}>
                                                        <Chip
                                                            label={file.name}
                                                            color="primary"
                                                            className={classes.chip}
                                                            onDelete={() => handleDeleteFile(file.name)}
                                                        />
                                                    </Grid>
                                                )
                                            }
                                            {
                                                uploadedFiles.length <= 0 &&
                                                <Grid size={12}>
                                                    <Typography variant='body2'>
                                                        No se ha cargado ningun archivo.
                                                    </Typography>
                                                </Grid>
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {
                                referrals.length > 0 &&
                                <Grid container spacing={1} style={{margin: '10px'}}>
                                    <Grid size={12}>
                                        <FormControlLabel
                                            label="Ver solo diferencias"
                                            control={
                                                <Switch 
                                                    name="checkedH"
                                                    color="primary"
                                                    onChange={handleShowDifferences}
                                                />
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            }
                            <Grid size={12}>
                                <Table
                                    rows={GetRows()}
                                    columns={columnsReception}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    actions={(item) =>
                                        <>
                                            <IconButton
                                                size='small'
                                                color='primary'
                                                onClick={() => setDetailSelected(item)}
                                            >
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton
                                                size='small'
                                                color='primary'
                                                onClick={() => handleRemoveProduct(item)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </>}
                                />
                                <TablePagination
                                    count={products?.length}
                                    rowsPerPageOptions={[10, 25, 100]}
                                    component="div"
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={(e, newPage) => setPage(newPage)}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </>
    );
}

export default MovementDetailsTable;